<script>
import { useI18n } from "vue-i18n";
import { mapGetters, mapActions } from "vuex";
import CompanyBox from "../components/CompanyBox.vue";

export default {
  components: { CompanyBox },
  computed: {
    ...mapGetters("company", ["getCompanies"]),
    ...mapGetters("meeting", ["getAppliedTimes", "getBookedTimes"]),
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  async mounted() {
    await this.fetchCompanies();
    const date = "2026-11-10";

    if (this.$store.state.token) {
      await Promise.all(
        this.getCompanies.map((company) =>
          this.fetchTimes({ companyId: company._id, date }).catch((err) => {
            console.error(`Failed to fetch times for ${company.name}:`, err);
          }),
        ),
      );
    }
  },
  methods: {
    ...mapActions("company", ["fetchCompanies"]),
    ...mapActions("meeting", ["fetchTimes"]),
  },
};
</script>

<template>
  <v-img
    src="https://fvlexgixfscdhipyjiib.supabase.co/storage/v1/object/public/pictures/startsida.jpg"
    cover
    height="100vh"
    class="d-flex align-center justify-center"
  >
    <div class="image-overlay"></div>
    <div class="overlay-content d-flex align-center justify-center text-center">
      <h1 class="text-h2 text-md-h1 font-weight-bold text-accent">
        e-day 2026
      </h1>
    </div>
  </v-img>

  <v-container fluid class="pa-0">
    <v-row justify="center">
      <v-col cols="11" md="9" class="text-center">
        <v-card flat>
          <v-card-text class="text-body-1 mt-4">
            <p>
              {{ t("home.intro") }}
            </p>

            <p class="mt-6">
              {{ t("home.meeting") }}
            </p>

            <p class="mt-6">
              {{ t("home.member") }}
              <a
                :href="t('home.memberLink')"
                target="_blank"
                rel="noopener noreferrer"
                class="font-weight-medium"
              >
                {{ t("home.memberLink") }}
              </a>
            </p>

            <p class="mt-6 mb-0">
              {{ t("home.networking") }}
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <p class="text-h3 text-center my-10 font-weight-bold">
      {{ t("company.featured") }}
    </p>
    <v-row class="mb-8">
      <v-col
        v-for="(company, index) in getCompanies?.filter(
          (c) => c.contactMeeting,
        ) || []"
        :key="index"
        cols="12"
        sm="6"
        md="6"
        lg="4"
        class="d-flex justify-center"
      >
        <CompanyBox :company="company" />
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.v-image__image {
  width: 100vw !important;
  height: 100vh !important;
}
.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(128, 0, 128, 0.5);
  z-index: 1;
}
.overlay-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}
</style>
